import type { ReactNode } from 'react';
import { NavLink, useParams } from 'react-router-dom';
import { auth } from '../lib/api';

export function Shell({ children }: { children: ReactNode }) {
  const { orgId } = useParams();
  const staff = auth.session!.staff;
  return (
    <div className="shell">
      <aside className="side">
        <div className="brand">Knock Knock<small>Platform</small></div>
        <nav>
          <NavLink to="/" end>Orgs</NavLink>
          {orgId && <NavLink to={`/orgs/${orgId}`} end>Activities</NavLink>}
          {orgId && <NavLink to={`/orgs/${orgId}/fans`}>Fans</NavLink>}
          {orgId && <NavLink to={`/orgs/${orgId}/economy`}>Points & tiers</NavLink>}
          {orgId && <NavLink to={`/orgs/${orgId}/webhooks`}>Webhooks</NavLink>}
          {staff.isPlatformAdmin && <NavLink to="/staff">Staff</NavLink>}
        </nav>
        <div className="who">
          <div>{staff.email}</div>
          <button className="link" onClick={() => void auth.signOut()}>Sign out</button>
        </div>
      </aside>
      <main className="main">{children}</main>
    </div>
  );
}
